export default {
  name: 'stepocurrence',
  props: {
    nivel: {
      Type: Number,
      Default: 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/stepocurrence/stepocurrence.js